import React from 'react';

export default ({ className }) => (
  <span className={className}>
    <svg viewBox="0 0 82 82">
      <path d="M17.46,81.62a4,4,0,0,1-4-4V4.38a4,4,0,0,1,8,0V77.62A4,4,0,0,1,17.46,81.62Z"/>
      <path d="M64.54,81.62a4,4,0,0,1-4-4V4.38a4,4,0,1,1,8,0V77.62A4,4,0,0,1,64.54,81.62Z"/>
    </svg>
  </span>
);